module.exports = __webpack_public_path__ + "img/ofanaim_no.06f4e48f.png";